import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

const getUpperCasedInitials = name => {
  const [firstName, lastName] = name.split(' ');
  // Provide fallback for .cjs environments
  if (typeof firstName === 'string' && firstName.length > 0 && typeof lastName === 'string' && lastName.length > 0) {
    return `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`;
  }
  if (typeof firstName === 'string' && firstName.length > 0) {
    return firstName[0].toUpperCase();
  }
};
const FallbackAvatar = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    border,
    borderColor,
    name,
    size,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    "aria-label": name,
    bg: "slate200",
    border: border // TODO: arbitrary calculation, but works
    ,
    borderColor: borderColor,
    borderRadius: "radiusFull",
    color: "text"
    // @ts-ignore
    ,
    fontSize: `${Number(size) / 2.5}px`
    // based on custom fontSize ratio
    ,
    lineHeight: `${size}px`,
    position: "relative",
    role: "img",
    size: size,
    textAlign: "center",
    textTransform: "uppercase" // getInitials() toUpperCase() fallback
    ,
    verticalAlign: "middle"
  }, rest), getUpperCasedInitials(name), children);
});

export { FallbackAvatar, getUpperCasedInitials };
